;(function ($) {
    'use strict';
    $(document).ready(function () {
        $('.hero-title-container').slick({
            infinite: true,
            arrows: true,
            dots: true,
            autoplay: true,
        });
    });
})(jQuery, window, document);
